export default "__VITE_ASSET__27b04753__"